export default __webpack_public_path__ + "static/media/mora.49482355.png";